import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import PropTypes from 'prop-types'
import React from 'react'

import SimpleIcon from '../../generic/components/SimpleIcon'

const ShowSearchFormButton = ({ onClick }) => (
  <div className='navbar-button-right'>
    <button
      className='navbar-button show-search-form-button qa-sf-sb'
      type='button'
      aria-label='Suchen'
      onClick={onClick}
    >
      <SimpleIcon icon={faSearch} />
    </button>
  </div>
)

ShowSearchFormButton.propTypes = {
  onClick: PropTypes.func
}

export default ShowSearchFormButton
